<template>
  <div>
    <b-row>
      <b-col
        xl="3"
        lg="4"
        md="5"
      >
        <FormCardProfileVue :loading="loading" />
      </b-col>
      <b-col
        xl="9"
        lg="8"
        md="7"
      >
        <b-tabs lazy>
          <b-tab
            v-if="verificarPermissao('ROLE_FUNCIONARIO_CONSULTAR')"
            :active="!$route.query.tab || $route.query.tab === 'pessoal'"
          >
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Pessoal</span>
            </template>
            <FormEmployee :loading="loading" />
          </b-tab>

          <b-tab
            v-if="verificarPermissao('ROLE_FINAN_CONSULTAR')"
            :active="$route.query.tab === 'financeiro'"
          >
            <template #title>
              <feather-icon icon="DollarSignIcon" />
              <span>Financeiro</span>
            </template>
            <FormFinacialVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ATEND_CONSULTAR')">
            <template #title>
              <feather-icon icon="PhoneIcon" />
              <span>Atendimento</span>
            </template>
            <FormAttendanceVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="LinkIcon" />
              <span>Vinculos</span>
            </template>
            <FormLinkVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileTextIcon" />
              <span>Documentos</span>
            </template>
            <FormDocumentationsVue />
          </b-tab>

          <b-tab disabled>
            <template #title>
              <feather-icon icon="CalendarIcon" />
              <span>Eventos</span>
            </template>
            <FormEventsVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_PROTOCOLO_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileIcon" />
              <span>Protocolos</span>
            </template>
            <FormProtocolVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_RELATORIO_CONSULTAR')">
            <template #title>
              <feather-icon icon="PrinterIcon" />
              <span>Relatorios</span>
            </template>
            <FormReportsVue />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'

import mixinsGlobal from '@/mixins'

const FormEmployee = () => import('../employees/forms/personal/FormEmployee.vue')
const FormFinacialVue = () => import('../employees/forms/finance/FormFinancial.vue')
const FormAttendanceVue = () => import('../employees/forms/attendance/FormAttendance.vue')
const FormDocumentationsVue = () => import('../employees/forms/documentations/FormDocumentations.vue')
const FormEventsVue = () => import('../employees/forms/events/FormEvents.vue')
const FormReportsVue = () => import('../employees/forms/report/GridReport.vue')
const FormLinkVue = () => import('../employees/forms/link/FormLink.vue')
const FormProtocolVue = () => import('../employees/forms/protocol/FormProtocol.vue')
const FormCardProfileVue = () => import('../employees/forms/personal/FormCardProfileEmployee.vue')

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    FormEmployee,
    FormFinacialVue,
    FormAttendanceVue,
    FormDocumentationsVue,
    FormEventsVue,
    FormReportsVue,
    FormCardProfileVue,
    FormLinkVue,
    FormProtocolVue,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    this.loading = true
    const allPrimis = []
    let employeePromise = null

    try {
      // 1. Inicia todas as chamadas de combos em paralelo
      if (this.verificarPermissao('ROLE_GENERO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboGenero'))
      }
      if (this.verificarPermissao('ROLE_ESTADO_CIVIL_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboEstadoCivil'))
      }
      if (this.verificarPermissao('ROLE_PROFISSAO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboProfissoes'))
      }
      if (this.verificarPermissao('ROLE_NATURALIDADE_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboNaturalidades'))
      }
      if (this.verificarPermissao('ROLE_NACIONALIDADE_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboNacionalidades'))
      }
      if (this.verificarPermissao('ROLE_TIPO_REGISTRO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboTypesRegister'))
      }
      if (this.verificarPermissao('ROLE_UF_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboUfs'))
      }
      if (this.verificarPermissao('ROLE_PREVIDENCIA_SOCIAL_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboPrevidenciaSocial'))
      }
      if (this.verificarPermissao('ROLE_TIPO_ENDERECO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboTipoEndereco'))
      }
      if (this.verificarPermissao('ROLE_SITUACAO_REGISTRO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboSituacaoRegistro'))
      }
      if (this.verificarPermissao('ROLE_SETOR_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('employeesAdministrativeModule/loadComboSetores'))
      }
      if (this.verificarPermissao('ROLE_FAIXA_CONTRIBUICAO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('combosModule/loadComboFaixaContribuicao'))
      }

      // 2. Inicia a busca dos dados do funcionário em paralelo
      if (this.verificarPermissao('ROLE_FUNCIONARIO_CONSULTAR')) {
        employeePromise = this.$store.dispatch('employeesAdministrativeModule/getEmployeeID', this.$route.params.id)
      }

      // 3. Aguarda o término de todas as requisições paralelas
      await Promise.all([...allPrimis, employeePromise].filter(p => p !== null))

      // 4. Se buscou o funcionário, processa os dados e prepara a edição
      if (employeePromise) {
        const response = await employeePromise
        const objectAssociate = response.data
        if (objectAssociate.foto) {
          objectAssociate.foto = `data:image/jpeg;base64,${objectAssociate.foto}`
        }
        await this.$store.dispatch(
          'employeesAdministrativeModule/prepareToEditFullEmployee',
          objectAssociate,
        )
      }

      this.loading = false
    } catch (error) {
      console.error(error)
      this.MensagemError('Error', 'Erro ao carregar dados da tela!')
      this.loading = false
      this.$router.go(-1)
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
